<div class="modal-overlay"></div>
<div class="wrapper" [class.wrapper-inverse-colors]="inverseColors">
    <button *ngIf="showBackButton" class="icon icon-arrow-back" (click)="backClicked.emit()"></button>
    <h2 i18n class="title-white">{{ title }}</h2>
    <h2 i18n>{{ message }}</h2>
    <div class="insert-rfid-card-anim"></div>
</div>
